import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=e561f38a&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=e561f38a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e561f38a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e561f38a')) {
      api.createRecord('e561f38a', component.options)
    } else {
      api.reload('e561f38a', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=e561f38a&scoped=true&", function () {
      api.rerender('e561f38a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ga8o4zVvNt5H/JS/comp/Voucher.vue"
export default component.exports